var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('paginated-server-table',{ref:"workorderPmsTable",attrs:{"title":"Service Actions","fields":_vm.tableColumns,"apiMethod":_vm.getEquipmentPms},on:{"error":_vm.emitError}})
}
var staticRenderFns = []

export { render, staticRenderFns }